// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_surface_texture_probe/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_surface_texture_probe: ModuleSchema = {
  "id": "core_surface_texture_probe",
  "uniqueId": "B3D_TX9PL",
  "createdAt": "2026-10-05T00:00:00Z",
  "updatedAt": "2026-10-28T14:58:32.983Z",
  "label": "Fuzzy Surface Texture",
  "description": "Một khối độc lập dùng hiệu ứng Fuzzy Skin, để gọi lại cho đế đèn hoặc bề mặt cong.",
  "category": "core_geometry",
  "tags": [
    "core",
    "texture",
    "surface",
    "fuzzy",
    "reusable"
  ],
  "sliders": [
    {
      "key": "textureDepth",
      "label": "Fuzzy Relief Depth",
      "min": 0.1,
      "max": 3,
      "default": 0.6,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "textureScale",
      "label": "Fuzzy Density",
      "min": 4,
      "max": 36,
      "default": 16,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "fuzzy",
      "label": "Fuzzy Surface",
      "default": "#ffa726",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "name": "Fuzzy Surface Texture",
      "parts": [
        {
          "name": "Fuzzy Surface Texture",
          "groupId": 0
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "name": "Fuzzy Surface Texture",
      "groupId": 0
    }
  ]
};
